<template>
    <div class="main">
        <ul class="course-filter">
            <li class="clearfix filter-item">
				<div class="fl filter-name">授课方式：</div>
				<div class="fl filter-tag">
					<a v-for="(courseTypeModel,index) in courseTypeList" :key="index" :class="{active:courseTypeModel.isActive}" @click="getCourseType(index,courseTypeModel.courseTypeId)" href="javascript:void(0);">{{courseTypeModel.courseName}}</a>
				</div>
			</li>
            <li class="clearfix filter-item">
				<div class="fl filter-name">级别：</div>
				<div class="fl filter-tag">
					<a v-for="(gradesModel,index) in gradeList" :key="index" :class="{active:gradesModel.isActive}"   @click="selectGrade(gradesModel.id)" href="javascript:void(0);">
						{{gradesModel.label}}
					</a>
				</div>
			</li>
            <li v-show="isShowSubject" class="clearfix filter-item">
				<div class="fl filter-name">阶段：</div>
				<div class="fl filter-tag">
					<a v-for="(subjectOptionModel,index) in subjectList" :key="index" :class="{active:subjectOptionModel.isActive}" @click="getSubject(subjectOptionModel.subjectId)"  href="javascript:void(0);">{{subjectOptionModel.subjectName}}</a>
				</div>
			</li>

        </ul>
    </div>
</template>
<script>
export default {
    data(){
        return {
            subject:'',             //阶段
            courseType: '',         //课程类型
            juniorId: '',           //级别
            isShowSubject: false,   //是否显示阶段
            gradeList:[
                {
                    id: -1,
                    label: '全部',
                    isActive: true
                },
                {
                    id: 0,
                    label: '预备级',
                    isActive: false
                },
                {
                    id: 1,
                    label: '一级',
                    isActive: false
                },
                {
                    id: 2,
                    label: '二级',
                    isActive: false
                },
                {
                    id: 3,
                    label: '三级',
                    isActive: false
                },
                {
                    id: 4,
                    label: '四级',
                    isActive: false
                },
                {
                    id: 5,
                    label: '五级',
                    isActive: false
                },
                {
                    id: 6,
                    label: '六级',
                    isActive: false
                }
            ],
            allSubjectList:[],
            subjectList:[],       
            courseTypeList:[
                {courseTypeId:"",courseName:'全部',isActive:true},
                {courseTypeId:"VIDEO",courseName:'录播课',isActive:false},
                {courseTypeId:"TEACH_METHOD_FACE",courseName:'面授课',isActive:false}
            ]
        }
    },
    created(){
        this.getAllSubjectList();
    },
    methods:{

        getLession(){
			// console.log(this.year,this.grade,this.subject,this.lessonType)
			this.$emit('change',{
				courseType:this.courseType,
				juniorId:this.juniorId,
				subject:this.subject
				
			})
        },
        
        //yeer 0 , 1 , 2  
		filterTo(juniorId){
			
			this.selectGrade(juniorId);
        },
        
        getCourseType(index,courseType){

            this.courseType = courseType;
            for(let i=0;i<this.courseTypeList.length;i++){
                if(index == i){
                    
					this.courseTypeList[i].isActive = true;
				}else{
					this.courseTypeList[i].isActive = false;
				}
            }
            
            this.getLession();
        },
        //加载所有的科目列表
        getAllSubjectList(){

            this.$http.post(this.baseUrl()+'/question/scope/subjectList','',{
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((successResp) => {
                this.allSubjectList = successResp.body.data.subjects;
            }
            );
        },
        //选择年级
        selectGrade(juniorId){

            for(let i=0;i<this.gradeList.length;i++){
                this.gradeList[i].isActive = false;
            }
            if(juniorId==-1){
                this.juniorId='';
                this.subject="";
                this.isShowSubject = false;
                this.gradeList[0].isActive = true;
            }else{
                this.juniorId = juniorId;

                for(var i=0;i<this.gradeList.length;i++){
                    

                    if(this.gradeList[i].id == juniorId){
                        this.gradeList[i].isActive = true;
                    }
                }

                let _gradeSubjects = [];

                var defaultSubject = {}
                defaultSubject.subjectId = 0
                defaultSubject.subjectName = '全部'; //添加了一个全部字段
                defaultSubject.isActive = true;  //直接让全部高亮
                _gradeSubjects.push(defaultSubject);

                for(let j=0;j<this.allSubjectList.length;j++){
                    console.log(this.allSubjectList[j])    
                    
                    if(this.allSubjectList[j].grade==juniorId){

                        
                        let model = this.allSubjectList[j];

                        let subjectInfo = {};
                        
                        let subjectName = model.subjectName;

                        subjectInfo.subjectName = subjectName.substr(2,subjectName.length);
                        subjectInfo.isActive = false;
                        subjectInfo.subjectId = model.subjectId;

                        //model = Object.assign({},model,{isActive:false});

                        _gradeSubjects.push(subjectInfo);
                    }

                }
                this.subjectList = _gradeSubjects;
                this.isShowSubject = true;
            }
            
            this.getLession();
            
        },
        //选择阶段
        getSubject(subjectId){

            if(subjectId == 0){
				this.subject = ''
			}else{
				this.subject = subjectId
            }
            
            for(let i=0;i<this.subjectList.length;i++){
                let model = this.subjectList[i]
				if(model.subjectId == subjectId){
					this.subjectList[i].isActive = true;
				}else{
					this.subjectList[i].isActive = false;
				}
            }

            this.getLession();
        }
    }
}
</script>
<style scoped>
    .course-filter{
        background: #fff;
        padding: 15px 20px 20px;
    }
    .course-filter li.filter-item{
        display: flex;       
        margin: 13px 0 8px;
    }
    .course-filter li .filter-name{
        color: #333;
        width: 120px;
        text-align: right;
        line-height: 34px;
    }
    .course-filter li .filter-tag{
        display: flex;
        width: 85%;
    }
    .course-filter li .filter-tag a{
        
        color: #333;
        margin:4px 8px; 
        height: 24px;
        line-height: 24px;
        padding: 0 10px;
        border-radius: 4px;
    }
    .course-filter li .filter-tag a:hover,
    .course-filter li .filter-tag a.active{
        background: #f49d40;
        color: #fff;
    }
</style>